import { useStoreActions } from '~/contexts';
import { useQueryState } from '~/hooks/reactQuery/useQueryState';
import { isLastOwnerQueryKey, lastOwnerCandidateUserId } from '../../ContactsCard.utils';
const neverLastOwner = ()=>Promise.resolve(false);
export const useIsLastOwner = (clientId, contact, param)=>{
    let { refreshOnHookMount } = param;
    const { api } = useStoreActions();
    const candidateUserId = lastOwnerCandidateUserId(contact);
    const { data } = useQueryState({
        queryKey: isLastOwnerQueryKey(candidateUserId, clientId),
        queryFn: candidateUserId == null ? neverLastOwner : ()=>api.user.isLastOwner(candidateUserId, clientId),
        enabled: candidateUserId != null,
        refreshOnHookMount
    });
    return {
        isLastOwner: data !== null && data !== void 0 ? data : false
    };
};
